
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 80.687 98.193"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"data-name":"Rectangle 36","fill":"none","d":"M0 0h80.687v98.193H0z"}})])]),_c('g',{attrs:{"data-name":"oil 1","clip-path":"url(#a)"}},[_c('path',{attrs:{"data-name":"Path 39","d":"M6.231 98.199a6.243 6.243 0 01-.921-12.42V16.353A6.241 6.241 0 016.2 3.94h5.332V-.001h14.563V3.94h48.324a6.055 6.055 0 014.414 1.8 6.239 6.239 0 01-3.455 10.609v69.436a6.275 6.275 0 015.3 6.179v.011a6.27 6.27 0 01-6.255 6.22H6.231zm.038-9.767a3.526 3.526 0 00-2.507 6.033 3.748 3.748 0 002.5 1.019h68.157a3.526 3.526 0 100-7.051h-1.758V13.705h1.757a3.526 3.526 0 002.507-6.033 3.731 3.731 0 00-2.5-1.016H23.378V2.715h-9.126v3.941H6.269a3.525 3.525 0 10-.03 7.049h1.787v74.723z","fill":"#4d4d4d"}}),_c('path',{attrs:{"data-name":"Path 40","d":"M27.197 59.831a12.365 12.365 0 1024.731 0c0-6.829-12.364-24.321-12.364-24.321S27.197 53.002 27.197 59.831","fill":"#e61010"}})])])
          )
        }
      }
    